import { useQuery } from '@apollo/client';

export default function _useQuery(...args) {
  const { error, ...result } = useQuery(...args);
  if (error) throw error;
  return result;
}
